import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideClientHydration } from '@angular/platform-browser';
import { Title, Meta } from '@angular/platform-browser';
import { routes } from './app.routes';
import { httpSecurityInterceptor } from './interceptors/http-security.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(
      withFetch(),
      withInterceptors([httpSecurityInterceptor])
    ),
    provideClientHydration(),
    Title,
    Meta
  ]
};
